import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./Styles/Custom.scss";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

ReactDOM.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>,
	document.getElementById("root")
);

//added service workers
serviceWorkerRegistration.unregister();
